export type LeadCatProduct = "crm" | "billing";

export interface ProductBrand {
  id: LeadCatProduct;
  name: string;
  descriptor: "CRM" | "Billing";
  workspaceLabel: string;
}

const assetBaseUrl = `${import.meta.env.BASE_URL}brand/`;

function brandAsset(filename: string): string {
  return `${assetBaseUrl}${filename}`;
}

export const leadCatBrand = {
  name: "LeadCat",
  tagline: "Lead Connect Convert",
  legalLine: "LeadCat is a product of Staminal Technologies Private Limited",
  marketing: {
    title: "LeadCat CRM | Capture, Manage and Convert Social Media Leads",
    description: "LeadCat is a social lead CRM that captures customer enquiries from Instagram, Facebook and WhatsApp and helps teams manage, follow up and convert them.",
  },
  products: {
    crm: {
      id: "crm",
      name: "LeadCat CRM",
      descriptor: "CRM",
      workspaceLabel: "CRM workspace",
    },
    billing: {
      id: "billing",
      name: "LeadCat Billing",
      descriptor: "Billing",
      workspaceLabel: "Billing workspace",
    },
  } satisfies Record<LeadCatProduct, ProductBrand>,
  assets: {
    logo: brandAsset("leadcat-logo.png"),
    stackedLogo: brandAsset("leadcat-logo-stacked.png"),
    symbol: brandAsset("leadcat-symbol.png"),
    wordmark: brandAsset("leadcat-wordmark.png"),
    icon32: brandAsset("leadcat-icon-32.png"),
    icon180: brandAsset("leadcat-icon-180.png"),
    icon512: brandAsset("leadcat-icon-512.png"),
    hero: brandAsset("leadcat-hero-1448.webp"),
    dashboardMascot: brandAsset("leadcat-dashboard-mascot.jpg"),
    socialPreview: brandAsset("leadcat-social-preview.png"),
    heroSrcSet: [
      `${brandAsset("leadcat-hero-640.webp")} 640w`,
      `${brandAsset("leadcat-hero-960.webp")} 960w`,
      `${brandAsset("leadcat-hero-1448.webp")} 1448w`,
    ].join(", "),
  },
} as const;

export function productBrand(product: LeadCatProduct): ProductBrand {
  return leadCatBrand.products[product];
}
